/**
 * @generated SignedSource<<d89330a12e304d1decdadfb7c7a699ca>>
 * @relayHash 93c0d8d16c4e77e0b03ed1162c0f98a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type versionMenuQuery$variables = {
  after?: string | null | undefined;
  first: number;
  jiraProjectIds: ReadonlyArray<string>;
};
export type versionMenuQuery$data = {
  readonly jira: {
    readonly versionsForProjects: {
      readonly edges: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"versionMenu_softwareBacklog_VersionMenuContent">;
      } | null | undefined>;
    };
  };
};
export type versionMenuQuery = {
  response: versionMenuQuery$data;
  variables: versionMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jiraProjectIds"
},
v3 = {
  "kind": "Literal",
  "name": "filter",
  "value": [
    "RELEASED",
    "UNRELEASED"
  ]
},
v4 = {
  "kind": "Variable",
  "name": "jiraProjectIds",
  "variableName": "jiraProjectIds"
},
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    },
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v3/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v4/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "versionMenuQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "alias": "versionsForProjects",
                "args": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "__versionBacklogPanelRelay_versionsForProjects_connection",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "JiraVersionEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "versionMenu_softwareBacklog_VersionMenuContent"
                        },
                        (v5/*: any*/),
                        {
                          "concreteType": "JiraVersion",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v6/*: any*/)
                          ]
                        }
                      ]
                    },
                    "action": "THROW",
                    "path": "jira.versionsForProjects.edges"
                  },
                  (v7/*: any*/)
                ]
              },
              "action": "THROW",
              "path": "jira.versionsForProjects"
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "versionMenuQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraVersionConnection",
            "kind": "LinkedField",
            "name": "versionsForProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraVersionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraVersion",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "versionId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "status"
                      },
                      {
                        "concreteType": "JiraProject",
                        "kind": "LinkedField",
                        "name": "project",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "projectId"
                          },
                          (v9/*: any*/)
                        ]
                      },
                      (v9/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  (v5/*: any*/)
                ]
              },
              (v7/*: any*/)
            ]
          },
          {
            "args": (v8/*: any*/),
            "filters": [
              "jiraProjectIds",
              "filter"
            ],
            "handle": "connection",
            "key": "versionBacklogPanelRelay_versionsForProjects",
            "kind": "LinkedHandle",
            "name": "versionsForProjects"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8de8818cd89ed97037d20d3a42434b738449fd91fe983e253e41993b4d843c3c",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "jira",
            "versionsForProjects"
          ]
        }
      ]
    },
    "name": "versionMenuQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ad42f90f36561f245c5fce9acfe51923";

export default node;
